import React, {Component} from 'react';
import "./style/OrderCartAuthenticationStyle.scss"
import {Link} from "react-router-dom";
import AuthenticationService from '../../../services/AuthenticationService';
import {connect} from "react-redux";

import CartInterector from "../../../domain/pages/cart/CartInterector";
import CartService from "../../../data/pages/cart/CartService";

class Authentication extends Component {

    state = {
        productCount: 0
    };

    async getCart(){
      new CartInterector(new CartService().getData())
    }

    componentDidMount() {

        this.getCart();
    }

    render() {
        const {handleClick, isLogged, cartData} = this.props;

        return (
            <div className="containerLogin">
                {isLogged ? (
                    <div onClick={handleClick}>
                        <Link to="/">Login </Link> /
                        <Link to="/register"> Register
                        </Link>
                    </div>
                ) : window.localStorage.getItem("user_type") === "buyer" ? (
                    <div className="settings">
                        <div className="cart">
                            {(cartData[0] && cartData[0].products_count > 0) &&
                                <span className="productCount"></span>
                            }
                            <Link to="/cart">
                                <img src={`${process.env.PUBLIC_URL}/images/cart.png`} alt="ico user"/>
                            </Link>
                        </div>
                        <div className="user">
                            <img src={`${process.env.PUBLIC_URL}/images/ico-user.png`} alt="ico user"/>
                        </div>

                        <div className="dropdownSettings-wrapper">
                            <div className="dropdownSettings">
                                <div className="hello">
                                    <small>Hello,</small>

                                    {window.localStorage.getItem("user")}
                                </div>
                                <div className="separator"/>
                                <ul className="dropdownSettings-menu">
                                    <>
                                        <li><Link to="/cart">Cart</Link></li>
                                        <li><Link to="/order">Orders</Link></li>
                                    </>
                                </ul>
                                <button className="logout" onClick={() => AuthenticationService.logout()}> Logout
                                </button>
                            </div>
                        </div>
                    </div>
                ):(
                    <span className="logoutSeller" onClick={() => AuthenticationService.logout()}> Logout</span>
                )}
            </div>
        );
    }
}

class OrderCartAuthentication extends Component {

    static isLogged() {
        return window.localStorage.getItem("user") === null;
    }


    componentDidMount() {

    }

    render() {
        const { handleClick, cartData } = this.props;

        return (
            <div className="orderCartAuthentication">
                <ul>
                    <li>
                        <div className="authentication">
                            <Authentication cartData={cartData} handleClick={handleClick} isLogged={OrderCartAuthentication.isLogged()} />
                        </div>
                    </li>
                </ul>
            </div>
        );
    }
};

function mapStateToProps(state) {
    return {
        cartData: state.cartEntity,
    }
}

export default connect(mapStateToProps)(OrderCartAuthentication);
